import { map } from 'lodash';
import { settings } from '~/config';

import { GET_FEATURE_LIST } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * Feature List Reducer
 * @param {*} state
 * @param {*} action
 */
export default function featureList(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_FEATURE_LIST}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_FEATURE_LIST}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action?.result,
        loaded: true,
        loading: false,
      };
    case `${GET_FEATURE_LIST}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}
